// Mirrors backend rules (phonenumbers): plain numbers are Indian mobiles; "+" numbers are international.
export function validateMobile(raw) {
  const v = (raw || "").trim();
  if (!v) return "Mobile number is required";
  if (/ext|x\d|#|;/i.test(v)) return "Please remove the extension";
  if (!/^\+?[\d\s\-()]+$/.test(v)) return "Use digits only, e.g. 98765 43210";
  let digits = v.replace(/\D/g, "");
  const intl = v.startsWith("+") || digits.startsWith("00");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (intl) {
    if (digits.startsWith("91")) return /^910?[6-9]\d{9}$/.test(digits) ? "" : "Enter a valid 10-digit Indian mobile number";
    return digits.length >= 8 && digits.length <= 15 ? "" : "Enter a valid international mobile number";
  }
  const local = digits.replace(/^0/, "").replace(/^91(?=\d{10}$)/, "");
  return /^[6-9]\d{9}$/.test(local) ? "" : "Enter a valid 10-digit mobile number starting with 6–9";
}

const KEY = "sm_tracked_orders";

export function saveTrackedOrder(o) {
  const list = getTrackedOrders().filter((x) => x.id !== o.id);
  list.unshift(o);
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 10)));
}

export function getTrackedOrders(slug) {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    const fresh = list.filter((x) => Date.now() - new Date(x.at).getTime() < 2 * 864e5);
    return slug ? fresh.filter((x) => x.slug === slug) : fresh;
  } catch {
    return [];
  }
}

export const trackUrl = (o) => `/order/${o.id}?token=${encodeURIComponent(o.token)}`;
